import { Pipe, PipeTransform } from '@angular/core';
import { NgxMaskPipe } from 'ngx-mask';

@Pipe({
    name: 'ssn',
    standalone: false
})
export class SSNPipe implements PipeTransform {
  constructor(private maskPipe: NgxMaskPipe) {}

  transform(value: string): string {
    return value ? value : '';
  }

  ssnTransform(value: string): string {
    return this.maskPipe.transform(value, '000-00-0000');
  }
}
